import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

function PrivateRoute({ children, adminOnly = false, requiresResearch = false, requiresCredits = false }) {
  const { 
    user, 
    loading, 
    isAdmin, 
    walletBalance, 
    hasActiveSubscription, 
    credits
  } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location.pathname }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" state={{ message: "Admins only" }} replace />;
  }

    

  // If the route requires credits and user has none (not admin, no subscription, no wallet, no credits)
  if (requiresCredits && !isAdmin && !hasActiveSubscription && walletBalance <= 0 && credits <= 0) {
    return <Navigate to="/account" state={{ 
      message: "You need funds, a subscription, or free credits to perform this action" 
    }} replace />;
  }

  return children;
}

export default PrivateRoute;